import { CalendarClock, FileSignature, Briefcase } from "lucide-react";
import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const ROWS = [
  {
    icon: CalendarClock,
    h: "On-site sessions",
    p: "Scheduled around shifts at plants, warehouses and sites.",
  },
  {
    icon: FileSignature,
    h: "Doctor-ordered care",
    p: "Work-related strain and injury, treated to an order.",
  },
  {
    icon: Briefcase,
    h: "Return to work",
    p: "Coordinated recovery, with confidential reporting.",
  },
];

const BG_IMG =
  "https://images.unsplash.com/photo-1645005512964-5057008b4425?q=85&w=1920&auto=format&fit=crop";

export default function Slide09Corporate() {
  return (
    <div className="relative">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={BG_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-bone2 via-bone2/90 to-bone2/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-bone2 via-transparent to-bone2/60" />
      </div>
      <div className="relative z-10 max-w-[760px]">
        <SlideTitle>
          In-plant care for <em className="italic text-gold">your workforce</em>
        </SlideTitle>
        <div className="mt-10 space-y-0">
          {ROWS.map((r, i) => (
            <FadeUp
              key={r.h}
              delay={0.1 + i * 0.09}
              className="flex gap-5 border-t border-ink/10 py-6 last:border-b"
            >
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/95 text-navy shadow-sm">
                <r.icon size={18} strokeWidth={1.8} />
              </div>
              <div>
                <h3 className="text-lg font-semibold tracking-tight">{r.h}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-mut">
                  {r.p}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
        <SlideConclusion delay={0.4}>
          A corporate tie-in that brings care within reach of the shift.
        </SlideConclusion>
      </div>
    </div>
  );
}
